export const preloadImage = (imageUrl: string): void => {
  const link = document.createElement("link");
  link.href = imageUrl;
  link.rel = "preload";
  link.as = "image";
  document.head.appendChild(link);
};
